import palette from "styles/palette";

const defaultTimingFunction = "cubic-bezier(0.165, 0.84, 0.44, 1)";

const helpers = {
  centerFlex: `
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  defaultTimingFunction,
  // @ts-ignore
  transition: (...props) => `
    transition-timing-function: ${defaultTimingFunction};
    transition-duration: .2s;
    transition-property: ${props.join(", ")};
    `,
  // @ts-ignore
  movingGradient: (color0, color40, color60, color100) => `
    background: -webkit-linear-gradient(left , ${color0} 0%, ${color40} 40%, ${color60} 60%, ${color100} 100%) repeat;
    -webkit-background-size: 50% 100%;
    -webkit-animation-name: moving-gradient;
    -webkit-animation-duration: 1s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
  `,
  // @ts-ignore
  styledScroll: (overflowY) => `
    overflow-y: ${overflowY};
    overflow-x: hidden;
    
    &::-webkit-scrollbar {
      width: 5px; // manage scrollbar width here
    }
    
    &::-webkit-scrollbar * {
      background: transparent; // manage scrollbar background color here
    }
    
    &::-webkit-scrollbar-track {
      width: 5px;
    }
    
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: transparent; // manage scrollbar thumb background color here
    }
    
    &:hover {
      &::-webkit-scrollbar-thumb {
        background: ${palette.gray300} !important;
      }
    }
  `,
  hideScroll: () => `
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  `,
  textEllipsis: (maxWidth: string) => `
    max-width: ${maxWidth};
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  `,
};

export default helpers;
